<template>
  <div id="choose-apply-order-list">
    <div class="head clearfix">
      <span class="c-6 f-14">开票清单</span>
      <span class="c-hover f-13 fr pointer" @click="selectInvoiceGoods">选择开票商品</span>
    </div>
    <el-table
      :data="selectedData"
      :header-cell-style="{
        background: '#f8f8f8',
        color: '#666',
        fontSize: '13px',
        borderBottom: 'none'
      }"
    >
      <el-table-column label="商品" min-width="21%" header-align="center">
        <template v-slot="scope">
          <div class="flex">
            <div>
              <el-image
                style="width:60px;height:60px;"
                :src="scope.row.itemImg | fileUrlAdapter"
              ></el-image>
            </div>
            <div class="m-l10">
              <div class="two-line c-3 f-14" style="line-height: 20px;">
                {{ scope.row.itemTitle || '商品名称' }}
              </div>
              <div class="f-12 m-t10 single-line" style="line-height: 1;">
                {{ scope.row.itemSkuTitle || scope.row.itemSubTitle || '商品描述' }}
              </div>
              <div class="f-12 m-t10" style="line-height: 1;">
                {{ scope.row.bizOrderId ? `订单编号: ${scope.row.bizOrderId}` : '' }}
              </div>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="下单日期" min-width="10%" align="center">
        <template v-slot="scope">
          <div class="c-3">{{ scope.row.orderCreateTime | dataFormat('yyyy-MM-dd') }}</div>
          <div class="c-3">{{ scope.row.orderCreateTime | dataFormat('hh:mm:ss') }}</div>
        </template>
      </el-table-column>
      <el-table-column label="单价" min-width="10%" align="center">
        <template v-slot="scope">
          <span class="c-3">{{ scope.row.itemPerAmount | currencyFormat }}</span>
        </template>
      </el-table-column>
      <el-table-column label="开票数量" min-width="8%" align="center">
        <template v-slot="scope">
          <span class="c-3"
            >{{ scope.row.itemSkuQuantity }}{{ scope.row.itemWeightUnit | exUnit(true) }}</span
          >
        </template>
      </el-table-column>
      <el-table-column label="开票重量" min-width="10%" align="center">
        <template v-slot="scope">
          <span class="c-3">{{
            scope.row.itemWeight | formatWeightWithUnitFix(scope.row.itemWeightUnit)
          }}</span>
        </template>
      </el-table-column>
      <el-table-column label="税率" min-width="8%" align="center">
        <template v-slot="scope">
          <span class="c-3">{{ scope.row.taxRate }}%</span>
        </template>
      </el-table-column>
      <el-table-column label="税额" min-width="12%" align="center">
        <template v-slot="scope">
          <span class="c-3">{{ scope.row.taxAmount | currencyFormat }}</span>
        </template>
      </el-table-column>
      <el-table-column label="开票金额" min-width="13%" align="center">
        <template v-slot="scope">
          <span class="c-3">{{ scope.row.invoiceAmount | currencyFormat }}</span>
        </template>
      </el-table-column>
      <el-table-column label="状态" min-width="8%" align="center">
        <template v-slot="scope">
          <span class="c-3" :class="{ 'c-hover': scope.row.settlementStatus === 1 }">{{
            scope.row.settlementStatus === 1 ? '待结算' : '已结算'
          }}</span>
        </template>
      </el-table-column>
    </el-table>
    <div class="footer c-3 f-14 font-b">
      <div></div>
      <div class="total">
        <span class="m-r25"
          >已选
          <span class="f-20 c-hover">{{ selectTotalCopy.totalItemSkuQuantity }}</span> 件</span
        >
        <span class="m-r25"
          ><span class="f-20 c-hover">{{
            selectTotalCopy.totalItemWeight | formatWeightWithUnit('TON', true)
          }}</span>
          吨</span
        >
        <span class="m-r25"
          >开票金额
          <span class="f-20 c-hover">{{
            selectTotalCopy.totalInvoiceAmount | currencyFormatNoUnit
          }}</span>
          元</span
        >
        <span class="m-r25"
          >税额
          <span class="f-20 c-hover">{{
            selectTotalCopy.totalTaxAmount | currencyFormatNoUnit
          }}</span>
          元</span
        >
        <el-button
          class="button"
          type="primary"
          :class="{ 'commit-disable': submitDisable }"
          @click="handleCommitClick"
          >确认</el-button
        >
      </div>
    </div>

    <el-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      title="待开票清单"
      width="1200px"
      @open="handleDialogOpen"
      @close="handleDialogClose"
    >
      <div class="clearfix m-b20">
        <el-input
          v-model="searchForm.bizOrderId"
          style="width:280px;margin-right:10px;"
          clearable
          placeholder="请输入订单编号"
        ></el-input>
        <el-button type="primary" @click="startSearch">搜索</el-button>
        <div class="fr">
          <span class="m-r10 f-13 c-6">下单时间</span>
          <el-date-picker
            v-model="searchForm.dateRang"
            type="daterange"
            range-separator="~"
            clearable
            style="width:280px;"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :default-time="['00:00:00', '23:59:59']"
            @change="handleDatePickerChange"
          >
          </el-date-picker>
        </div>
      </div>
      <el-table
        :data="orderListData"
        height="260"
        :header-cell-style="{
          background: '#f8f8f8',
          color: '#666',
          fontSize: '13px',
          borderBottom: 'none'
        }"
        ref="selectTable"
      >
        <el-table-column width="30">
          <template v-slot:header>
            <el-checkbox
              :value="selectTotal.selectAll"
              @change="handleSelectAllChange"
            ></el-checkbox>
          </template>
          <template v-slot="scope">
            <el-checkbox
              :value="scope.row.$check"
              @change="val => handleSelectChange(scope.row, val)"
            ></el-checkbox>
          </template>
        </el-table-column>
        <el-table-column label="商品" min-width="21%" header-align="center">
          <template v-slot:header>
            <span class="fl">全选</span>
            <span>商品</span>
          </template>
          <template v-slot="scope">
            <div class="flex">
              <div>
                <el-image
                  style="width:60px;height:60px;"
                  :src="scope.row.itemImg | fileUrlAdapter"
                ></el-image>
              </div>
              <div class="m-l10">
                <div class="two-line c-3 f-14" style="line-height: 20px;">
                  {{ scope.row.itemTitle || '商品名称' }}
                </div>
                <div class="f-12 m-t10 single-line" style="line-height: 1;">
                  {{ scope.row.itemSkuTitle || scope.row.itemSubTitle || '商品描述' }}
                </div>
                <div class="f-12 m-t10" style="line-height: 1;">
                  {{ scope.row.bizOrderId ? `订单编号: ${scope.row.bizOrderId}` : '' }}
                </div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="下单日期" min-width="10%" align="center">
          <template v-slot="scope">
            <div class="c-3">{{ scope.row.orderCreateTime | dataFormat('yyyy-MM-dd') }}</div>
            <div class="c-3">{{ scope.row.orderCreateTime | dataFormat('hh:mm:ss') }}</div>
          </template>
        </el-table-column>
        <el-table-column label="单价" min-width="10%" align="center">
          <template v-slot="scope">
            <span class="c-3">{{ scope.row.itemPerAmount | currencyFormat }}</span>
          </template>
        </el-table-column>
        <el-table-column label="开票数量" min-width="8%" align="center">
          <template v-slot="scope">
            <span class="c-3"
              >{{ scope.row.itemSkuQuantity }}{{ scope.row.itemWeightUnit | exUnit(true) }}</span
            >
          </template>
        </el-table-column>
        <el-table-column label="开票重量" min-width="10%" align="center">
          <template v-slot="scope">
            <span class="c-3">{{
              scope.row.itemWeight | formatWeightWithUnitFix(scope.row.itemWeightUnit)
            }}</span>
          </template>
        </el-table-column>
        <el-table-column label="税率" min-width="8%" align="center">
          <template v-slot="scope">
            <span class="c-3">{{ scope.row.taxRate }}%</span>
          </template>
        </el-table-column>
        <el-table-column label="税额" min-width="12%" align="center">
          <template v-slot="scope">
            <span class="c-3">{{ scope.row.taxAmount | currencyFormat }}</span>
          </template>
        </el-table-column>
        <el-table-column label="开票金额" min-width="13%" align="center">
          <template v-slot="scope">
            <span class="c-3">{{ scope.row.invoiceAmount | currencyFormat }}</span>
          </template>
        </el-table-column>
        <el-table-column label="状态" min-width="8%" align="center">
          <template v-slot="scope">
            <span class="c-3" :class="{ 'c-hover': scope.row.settlementStatus === 1 }">{{
              scope.row.settlementStatus === 1 ? '待结算' : '已结算'
            }}</span>
          </template>
        </el-table-column>
        <template v-slot:append>
          <div class="loadmore" v-if="searchForm.pageNo < total" @click="loadMore">
            <span> <i class="el-icon-refresh-right"></i> 点击加载更多</span>
          </div>
        </template>
      </el-table>
      <div class="footer c-3 f-14 font-b">
        <el-checkbox :value="selectTotal.selectAll" @change="handleSelectAllChange"
          >全选</el-checkbox
        >
        <div class="total">
          <span class="m-r25"
            >已选 <span class="f-20 c-hover">{{ selectTotal.totalItemSkuQuantity }}</span> 件</span
          >
          <span class="m-r25"
            ><span class="f-20 c-hover">{{
              selectTotal.totalItemWeight | formatWeightWithUnit('TON', true)
            }}</span>
            吨</span
          >
          <span class="m-r25"
            >开票金额
            <span class="f-20 c-hover">{{
              selectTotal.totalInvoiceAmount | currencyFormatNoUnit
            }}</span>
            元</span
          >
          <span class="m-r25"
            >税额
            <span class="f-20 c-hover">{{
              selectTotal.totalTaxAmount | currencyFormatNoUnit
            }}</span>
            元</span
          >
          <el-button
            class="button"
            type="primary"
            :disabled="selectTotal.totalItemSkuQuantity === 0"
            @click="confirmSelect"
            >确认</el-button
          >
        </div>
      </div>
    </el-dialog>

    <el-dialog title="提示" :visible.sync="submitDialogVisible" width="400px">
      <span>确认提交开票申请?</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="submitDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
const defaultSearchForm = {
  bizOrderId: '',
  dateRang: null,
  pageNo: 1,
  pageSize: 10
}

export default {
  name: 'ApplyOrderList',
  props: {
    addressInfo: {
      type: Object,
      default: null
    },
    invoiceInfo: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      selectedData: [],
      selectTotalCopy: {
        totalItemSkuQuantity: 0,
        totalItemWeight: 0,
        totalInvoiceAmount: '',
        totalTaxAmount: ''
      },
      dialogVisible: false,
      searchForm: { ...defaultSearchForm },
      orderListData: [],
      total: 0,
      selectTotal: {
        selectAll: false,
        totalItemSkuQuantity: 0,
        totalItemWeight: 0,
        totalInvoiceAmount: '',
        totalTaxAmount: ''
      },
      submitDialogVisible: false
    }
  },
  computed: {
    submitDisable() {
      if (
        this.addressInfo &&
        (this.invoiceInfo.id || this.invoiceInfo._id) &&
        this.selectedData.length > 0
      ) {
        return false
      } else {
        return true
      }
    }
  },
  filters: {
    currencyFormatNoUnit(input) {
      if (typeof input === 'string') {
        input = parseFloat(input)
        if (isNaN(input)) {
          return '--'
        }
      } else if (typeof input !== 'number') {
        return '--'
      }
      let result = 0
      if (input) {
        result = input / 100
        result = String(result.toFixed(2))
        let re = /(-?\d+)(\d{3})/
        while (re.test(result)) {
          result = result.replace(re, '$1,$2')
        }
      }
      return `${result}`
    }
  },
  methods: {
    handleCommitClick() {
      if (!this.addressInfo) {
        this.$message.warning('请选择邮寄地址')
        return
      }
      if (!(this.invoiceInfo.id || this.invoiceInfo._id)) {
        this.$message.warning('请完善开票信息')
        return
      }
      if (this.selectedData.length === 0) {
        this.$message.warning('请选择开票商品')
        return
      }
      this.submitDialogVisible = true
    },
    confirmSelect() {
      this.orderListData.forEach(ele => {
        if (ele.$check) {
          this.selectedData.push(ele)
        }
      })
      Object.keys(this.selectTotalCopy).forEach(key => {
        this.selectTotalCopy[key] = this.selectTotal[key]
      })
      this.dialogVisible = false
    },
    handleSelectChange(row, val) {
      row.$check = val
      this.calculationSelectAll()
      this.calculationTotalData()
    },
    handleSelectAllChange(val) {
      this.selectTotal.selectAll = val
      this.orderListData.forEach(ele => {
        ele.$check = val
      })
      this.calculationTotalData()
    },
    calculationSelectAll() {
      if (this.orderListData.length === 0) {
        this.selectTotal.selectAll = false
        return
      }
      const exist = this.orderListData.find(ele => {
        if (!ele.$check) {
          return true
        }
        return false
      })
      this.selectTotal.selectAll = exist ? false : true
    },
    async calculationTotalData() {
      const temp = []
      this.orderListData.forEach(ele => {
        if (ele.$check) {
          temp.push(ele.id)
        }
      })
      if (temp.length === 0) {
        this.selectTotal.totalItemSkuQuantity = 0
        this.selectTotal.totalItemWeight = 0
        this.selectTotal.totalInvoiceAmount = '--'
        this.selectTotal.totalTaxAmount = '--'
      } else {
        const { success, data } = await this.$post('invoice.seller.getInvoicePendingTotalResult', {
          request: { invoicePendingItemId: temp }
        })
        if (success && data[0]) {
          this.selectTotal.totalItemSkuQuantity = data[0].invoiceQuantity
          this.selectTotal.totalItemWeight = data[0].invoiceWeight
          this.selectTotal.totalInvoiceAmount = data[0].invoiceAmount
          this.selectTotal.totalTaxAmount = data[0].taxAmount
        }
      }
    },
    selectInvoiceGoods() {
      this.dialogVisible = true
    },
    handleDialogOpen() {
      this.selectedData = []
      this.selectTotalCopy.totalItemSkuQuantity = 0
      this.selectTotalCopy.totalItemWeight = 0
      this.selectTotalCopy.totalInvoiceAmount = ''
      this.selectTotalCopy.totalTaxAmount = ''
      this.getInvoiceData()
    },
    handleDialogClose() {
      this.orderListData = []
      this.total = 0
      this.searchForm = { ...defaultSearchForm }
    },
    loadMore() {
      this.getInvoiceData(true)
    },
    startSearch() {
      this.searchForm.pageNo = 1
      this.getInvoiceData()
    },
    handleDatePickerChange(val) {
      this.getInvoiceData()
    },
    async getInvoiceData(loadmore = false) {
      const params = { buyerOrgId: this.$route.query.orgId }
      Object.keys(this.searchForm).forEach(key => {
        if (this.searchForm[key]) {
          if (key === 'dateRang') {
            if (this.searchForm[key].length === 2) {
              params.startOrderCreateTime = Date.parse(this.searchForm[key][0])
              params.endOrderCreateTime = Date.parse(this.searchForm[key][1])
            }
          } else {
            params[key] = this.searchForm[key]
          }
        }
      })
      if (loadmore) {
        params.pageNo = params.pageNo + 1
      }
      const { success, data } = await this.$post('invoice.seller.queryInvoicePendingByOrg', {
        request: params
      })
      if (success && data[0] && data[0].list && data[0].list.length > 0) {
        data[0].list.forEach(ele => {
          ele.$check = false
        })
        if (loadmore) {
          this.searchForm.pageNo = params.pageNo
          this.orderListData.push(...data[0].list)
        } else {
          this.orderListData = data[0].list
          this.total = data[0].totalPage
          this.$nextTick(() => {
            this.$refs.selectTable.doLayout()
          })
        }
      } else {
        if (!loadmore) {
          this.orderListData = []
          this.total = 0
        }
      }
      this.calculationSelectAll()
      this.calculationTotalData()
    },
    async submit() {
      //快递收货人信息 deliveryType 寄送方式(1.邮寄2.自提) 默认邮寄
      const invoiceExpress = { deliveryType: 1 }
      Object.keys(this.addressInfo).forEach(key => {
        if (key === 'recipientsName') {
          invoiceExpress.expressConsignee = this.addressInfo[key]
        } else if (key === 'recipientsPhone') {
          invoiceExpress.expressPhone = this.addressInfo[key]
        } else if (key === 'detailAddress') {
          invoiceExpress.expressAddress = this.addressInfo[key]
        } else {
          invoiceExpress[key] = this.addressInfo[key]
        }
      })

      //organization
      const organization = { ...this.invoiceInfo, orgId: this.$route.query.orgId }

      //待开票sku主键ids
      const pendingitemIds = []
      this.selectedData.forEach(ele => {
        pendingitemIds.push(ele.id)
      })

      const invoiceApply = { invoiceExpress, organization, pendingitemIds }

      const { success, data } = await this.$post('invoice.seller.apply', {
        request: { invoiceApply }
      })
      if (success && data[0] && data[0].value) {
        this.submitDialogVisible = false
        this.$router.replace({ name: 'InvoiceList' })
      }
    }
  }
}
</script>

<style lang="less">
#choose-apply-order-list {
  .head-row {
    background: red;
    font-size: 13px;
  }
  .row-disable {
    opacity: 0.5;
  }
  .el-image__inner {
    width: 60px;
    height: 60px;
  }
}
</style>

<style lang="less" scoped>
#choose-apply-order-list {
  .head {
    width: 100%;
    margin-top: 20px;
    height: 44px;
    line-height: 44px;
  }
  .loadmore {
    width: 100%;
    height: 60px;
    line-height: 60px;
    text-align: center;
    font-size: 12px;
    color: #333;
    cursor: pointer;
    &:hover {
      color: #f0242e;
    }
  }
  .footer {
    width: 100%;
    height: 60px;
    line-height: 60px;
    border: 2px solid #f8f8f8;
    padding-left: 20px;
    margin-top: 20px;
    display: flex;
    justify-content: space-between;
  }
  .total {
    display: flex;
    align-items: center;
  }
  .button {
    width: 150px;
    height: 56px;
    border-radius: 0;
  }
  .commit-disable {
    color: #fff;
    background-color: #f89297;
    border-color: #f89297;
  }
}
</style>
